import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { stateSelectors } from "@client/selectors";
import { type AppState, ScreenType } from "@client/types";
import classnames from "classnames";
import { toggleSidePanel } from "./actions";
import SidePanel, { type ActionProps, INVISIBLE_PROPS, type MapProps } from "./component";
import {
  contentStyleSelector,
  isSidePanelStaticSelector,
  sidePanelAppearanceSelector,
  sidePanelColorOptionsSelector,
  sidePanelPositionSelector,
  sidePanelTextColorSelector,
  styleSelector,
  visibilitySelector
} from "./selectors";

export const mapStateToProps = (state: AppState): MapProps & WithIsVisibleHOCProps => {
  const layoutId = stateSelectors.page.layoutId(state);
  if (!layoutId) return INVISIBLE_PROPS;

  const visibility = visibilitySelector(state);
  if (!visibility.isVisible) return INVISIBLE_PROPS;

  const appearance = sidePanelAppearanceSelector(state);
  const colorOptions = sidePanelColorOptionsSelector(state);
  const isStatic = isSidePanelStaticSelector(state);
  const position = sidePanelPositionSelector(state);
  const textColor = sidePanelTextColorSelector(state);

  const {
    viewport,
    widgets: { sidePanel }
  } = state;

  return {
    isVisible: true,
    isToggled: sidePanel.isToggled,
    className: classnames("side-panel text-center", position, appearance, {
      active: sidePanel.isToggled || (isStatic && viewport.screen === ScreenType.Desktop)
    }),
    contentClassName: classnames("side-panel-content", appearance, colorOptions, {
      [textColor]: colorOptions === "wsc-sidepanel-custom"
    }),
    contentStyle: contentStyleSelector(state),
    style: styleSelector(state)
  };
};

const mapDispatchToProps = (dispatch, props: Partial<ActionProps>): ActionProps => ({
  hideSidePanel: () => dispatch(toggleSidePanel()),
  onDoubleClick: props.onDoubleClick
});

export default connectCustom(mapStateToProps, mapDispatchToProps)(SidePanel);
